import { call, put, cancelled, select } from 'redux-saga/effects';
import {
  signalApiRequestStart,
  signalApiRequestEnd,
  signalApiRequestCancelled,
} from 'actions';
import endpoints from 'endpoints';
import { isFunction, isEmpty } from 'lodash';

export default function* apiSaga(action, payload = {}) {
  const { endpointArgs, type } = action;
  const endpointInfo = endpoints[type];
  const { endpoint, apiFunc } = endpointInfo;

  if (endpointInfo === undefined) {
    throw new Error(`${type} does not involve an API call.`);
  }
  yield put(signalApiRequestStart(type));
  const endpointUrl = isFunction(endpoint) ? endpoint(endpointArgs) : endpoint;

  try {
    const token = yield select(state => state.auth.token);
    const response = yield call(apiFunc, endpointUrl, payload, token);
    yield put(signalApiRequestEnd(type, response));
    return response;
  } finally {
    if (yield cancelled()) {
      yield put(signalApiRequestCancelled(action.type));
    }
  }
}

export function apiActionSagaTemplate(successCreator, failureCreator = null) {
  return function*(action) {
    let response = yield call(apiSaga, action, action.payload);
    if (isEmpty(response.errors)) {
      yield put(successCreator(response));
    } else if (failureCreator !== null) {
      yield put(failureCreator(response));
    }
  };
}



// WEBPACK FOOTER //
// ./src/sagas/apiSaga.js